<template>
  <section class="step-card-set">
    <h2
      v-if="heading"
      class="step-card-set__heading"
      v-html="heading"
    />
    <cdr-text
      v-if="subheading"
      class="step-card-set__subheading"
      tag="p"
    >
      {{ subheading }}
    </cdr-text>
    <div class="step-card-set__track-wrapper">
      <ol
        class="step-card-set__track-slider"
        tabindex="0"
      >
        <StepCard
          v-for="({ key, ...props }, index) in steps"
          :key="key"
          :index="index + 1"
          :class="`step-card--second-row`"
          :lazy-load="true"
          v-bind="props"
          :member-moment="memberMoment"
        />
      </ol>
    </div>
  </section>
</template>

<script>
import { CdrText } from '@rei/cedar';
import StepCard from './StepCard.vue';

export default {
  name: 'StepCardSet',
  components: {
    CdrText,
    StepCard,
  },
  props: {
    heading: {
      type: String,
      required: true,
    },
    subheading: {
      type: String,
      required: true,
    },
    steps: {
      type: Array,
      required: true,
    },
    memberMoment: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.step-card-set {
  margin: $cdr-space-four-x 0;
  @include cdr-container;
  padding: 0;

  &__heading {
    @include cdr-text-heading-serif-800;
    color: $cdr-color-text-primary;
    text-align: center;
    margin-bottom: $cdr-space-one-x;
    padding: 0 $cdr-space-one-x;
  }

  &__subheading {
    @include cdr-text-body-300;
    color: $cdr-color-text-primary;
    text-align: center;
    margin-bottom: $cdr-space-two-x;
    padding: 0 $cdr-space-one-x;
  }

  &__track-wrapper {
    overflow: auto;
    padding-bottom: $cdr-space-half-x;
  }

  &__track-slider {
    display: flex;
    padding-inline-start: 0; // byproduct of the <ol> wrapper
    margin: 0;

    @include cdr-md-mq-up {
      overflow: initial;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: $cdr-space-two-x;
    }
  }

  // overrides for step-card styles
  .step-card {
    flex: 1 0 264px;
    max-width: 264px;
    margin-left: $cdr-space-one-x;

    &:last-child {
      margin-right: $cdr-space-one-x;
    }

    // position cards into 2-top 3-bottom grid
    @include cdr-md-mq-up {
      max-width: initial;
      margin-left: 0;

      &:nth-child(1) {
        grid-column: 1 / span 1;
      }

      &:nth-child(2) {
        grid-column: 2 / span 1;
      }

      &:nth-child(3) {
        grid-column: 3 / span 1;
        grid-row: 1;
        margin-right: 0;
      }
    }
  }

  .step-card__title {
    @include cdr-text-subheading-sans-400;
  }

  .step-card__text {
    @include cdr-text-utility-sans-300;
    color: $cdr-color-text-brand;
  }

  .step-card__image {
    width: 144px;
  }

  @include cdr-md-mq-up {
    .step-card__inner {
      padding-top: 27%;
      margin-top: 4.6rem;
    }

    .step-card__title {
      @include cdr-text-subheading-sans-600;
      margin-bottom: $cdr-space-half-x;
    }

    .step-card__text {
      @include cdr-text-utility-sans-400;
    }

    .step-card__image {
      bottom: 73%;
    }
  }

  .step-card__inner {
    background-color: $cdr-color-background-secondary;
    height: 320px;

    @include cdr-md-mq-up {
      padding-top: 26%;
      height: 300px;
    }

    @include cdr-lg-mq-up {
      padding-top: 27%;
    }
  }

}
</style>
